import Layout from "../elements/templates/Layout";
import Header from "../elements/organisms/Header";
// import SearchResultLayout from "../componenets/post/SearchResultLayout";

const SearchResult = (props) => {
  return (
    <Layout>
      <Header />
      {/* <SearchResultLayout /> */}
    </Layout>
  );
};

export default SearchResult;
